import React, {useId} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, createSlotRecipeContext} from '@chakra-ui/react3'
import StackableImage from '../../../leap/components/stackable-image'
import {engravingStackableImageRecipe} from './engraving-stackable-image.recipe'

const {useRecipeResult} = createSlotRecipeContext({
    recipe: engravingStackableImageRecipe
})

const EngravingStackableImage = ({alt, images, engraveText, isExpanded = false, ...rest}) => {
    const engravingPathId = useId()
    const {styles} = useRecipeResult({isExpanded})
    const {formatMessage} = useIntl()
    const updatedAlt = engraveText
        ? formatMessage(
              {
                  id: 'configurator.step.engraving.aria-label',
                  defaultMessage: '{alt} - Engraving: {engraveText}'
              },
              {alt, engraveText}
          )
        : alt

    return (
        <StackableImage
            images={images}
            alt={updatedAlt}
            {...rest}
            tabIndex={-1}
            // used by the engraving text layer style
            containerType="size"
            css={styles.image}
        >
            {engraveText && (
                <Box aria-hidden="true" layerStyle="engraving.text" zIndex={10}>
                    <svg width="1" height="1" overflow="visible" focusable="false">
                        {/* Defines the arc followed by the engraving text. */}
                        <defs>
                            <path id={engravingPathId} d="M -200 -32 Q 0 32 200 -32" />
                        </defs>
                        <text fill="currentColor">
                            <textPath
                                href={`#${engravingPathId}`}
                                startOffset="50%"
                                textAnchor="middle"
                            >
                                {engraveText}
                            </textPath>
                        </text>
                    </svg>
                </Box>
            )}
        </StackableImage>
    )
}

EngravingStackableImage.propTypes = {
    alt: PropTypes.string,
    images: PropTypes.array,
    product: PropTypes.object,
    engraveText: PropTypes.string,
    isExpanded: PropTypes.bool,
    widths: PropTypes.object
}

export default EngravingStackableImage
